/*
 * ===============================================================================================================
 *                                Copyright 2023, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
export const selectUsers = (state: { assignedUsers: any }) => state.assignedUsers.users;
export const selectUsersLoading = (state: { assignedUsers: any }) => state.assignedUsers.loading;
export const selectUsersError = (state: { assignedUsers: any }) => state.assignedUsers.error;
export const selectPaginationDetails = (state: { assignedUsers: any }) => state.assignedUsers.page;
